import { render } from "./CreatePokokDoaView.vue?vue&type=template&id=5fa92494&ts=true"
import script from "./CreatePokokDoaView.vue?vue&type=script&lang=ts"
export * from "./CreatePokokDoaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__